import {Component, Input, Output, EventEmitter, ViewChild, OnInit} from '@angular/core';
import {MicroSelectComponent} from "../select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
  selector: 'micro-blockAllowType-select',
  templateUrl: './blockAllowType-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: BlockAllowTypeSelectComponent
    }
  ]
})
export class BlockAllowTypeSelectComponent implements OnInit, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  blockAllowTypeChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  blockAllowType:any = '';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  options:any[] = [
    {id: "NA"},
    {id: "BLOCK"},
    {id: "ALLOW"}
  ];

  onChange = (blockAllowType) => {};
  onTouched = () => {};
  touched = false;


  change(e) {
    this.onChange(e);
    this.blockAllowTypeChange.emit(e);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  constructor() {
  }

  ngOnInit() {
    this.sel.loading = false;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(blockAllowType: any): void {
    this.blockAllowType = blockAllowType;
  }
}
